module.exports = __webpack_public_path__ + "img/goodcard.86985c64.png";